// Section 22 Build tab (stream M3a), the tab root: reads the store's signals, builds the view
// models and dispatches the Build actions. Buildings owned (condition, effect, upkeep, repair),
// the build queue, what can be queued, housing, and the Tools panel (Section 10). Every other
// component in this folder takes props.
import { useComputed } from '@preact/signals';
import {
  cancelBuild,
  draft,
  game,
  moveBuild,
  pauseBuild,
  queueBuild,
  queueRepair,
  setHousingPolicy,
  setToolAllocation,
  setToolOverride,
  status,
  unqueueBuild,
} from '../../store';
import { jobLabel } from '../../viewModels/people';
import { buildVM } from '../../viewModels/build';
import { toolsVM } from '../../viewModels/tools';
import { buildText } from '../text/en';
import { ToolsPanel } from '../tools/tools-panel';
import { BuildOptions } from './build-options';
import { BuildQueue } from './build-queue';
import { HousingPanel } from './housing-panel';
import { OwnedBuildings } from './owned-buildings';
import './build.css';

export function BuildTab() {
  const build = useComputed(() => (game.value === null ? null : buildVM(game.value, draft.value)));
  const tools = useComputed(() => (game.value === null ? null : toolsVM(game.value, draft.value)));
  const vm = build.value;
  const tvm = tools.value;
  if (vm === null || tvm === null) return null;
  const canEdit = status.value === 'deciding';
  return (
    <div class="build">
      <section class="build__section" aria-labelledby="build-queue-title">
        <h3 id="build-queue-title">{buildText.queueTitle}</h3>
        <BuildQueue
          rows={vm.queue}
          cancelled={vm.cancelled}
          builders={vm.builders}
          pointsPerSeason={vm.pointsPerSeason}
          stock={vm.stock}
          canEdit={canEdit}
          onMove={(id, to) => moveBuild(id, to)}
          onPause={(id, paused) => pauseBuild(id, paused)}
          onCancel={(id) => cancelBuild(id)}
          onRemove={(i) => unqueueBuild(i)}
        />
      </section>
      <section class="build__section" aria-labelledby="build-owned-title">
        <h3 id="build-owned-title">{buildText.buildingsTitle}</h3>
        <OwnedBuildings rows={vm.buildings} canEdit={canEdit} onRepair={(id) => queueRepair(id)} />
      </section>
      <section class="build__section" aria-labelledby="build-options-title">
        <h3 id="build-options-title">{buildText.optionsTitle}</h3>
        <BuildOptions
          options={vm.options}
          stock={vm.stock}
          canEdit={canEdit}
          onQueue={(type) => queueBuild(type)}
        />
      </section>
      <section class="build__section" aria-labelledby="build-housing-title">
        <h3 id="build-housing-title">{buildText.housingTitle}</h3>
        <HousingPanel
          housing={vm.housing}
          canEdit={canEdit}
          onChange={(policy) => setHousingPolicy(policy)}
        />
      </section>
      <ToolsPanel
        vm={tvm}
        canEdit={canEdit}
        jobLabel={jobLabel}
        onPolicy={(option) => setToolAllocation(option)}
        onPin={(id, has) => setToolOverride(id, has ? true : null)}
      />
    </div>
  );
}
